import { create } from 'zustand'

interface ModalState {
   isCampaignLiveModalOpen: boolean
   openCampaignLiveModal: () => void
   closeCampaignLiveModal: () => void
}

export const useCampaignLiveModalStore = create<ModalState>((set) => ({
   isCampaignLiveModalOpen: false,
   openCampaignLiveModal: () => set({ isCampaignLiveModalOpen: true }),
   closeCampaignLiveModal: () => set({ isCampaignLiveModalOpen: false }),
}))
